const getEntityIssues = (itemsToCheck, entityData) => {
  let output = [];
  for (let i in itemsToCheck) {
    let valid = true;
    switch (itemsToCheck[i]) {
      case 'address':
        valid = entityData.address.isPopulated;
        break;
      case 'location':
        valid = entityData.location.isValid;
        break;
      default:
        valid = !(entityData[itemsToCheck[i]] === null || entityData[itemsToCheck[i]] === '');
        break;
    }
    if (!valid) output.push(itemsToCheck[i]);
  }
  return output;
};

export { getEntityIssues };
